import React from 'react';

const PUBLIC_OPTIONS = [
  { id: 'faculty_staff', title: 'Faculty / Staff', hint: 'Employee ID + registered phone or email' },
  { id: 'dependent', title: 'Dependent', hint: 'Family member linked to a campus staff record' },
  { id: 'non_dependent', title: 'Non-dependent / Guest', hint: 'Guest, project staff, intern, contractor, or other' },
];

/** Same labels as referral — used when a logged-in faculty/staff books in the portal. */
const PORTAL_FACULTY_OPTIONS = [
  { id: 'self', title: 'Self', hint: 'Book an OPD visit in your name' },
  { id: 'dependent', title: 'Dependent', hint: 'Spouse, child, or parent on your record' },
  { id: 'non_dependent', title: 'Non-dependent', hint: 'Guest / relative not on your family tree' },
];

/** Patient category — consulting flow only (never shown for referral). */
export default function BookingCategoryStep({ primary, value, onPick, onBack, allowedCategories }) {
  const allowed = Array.isArray(allowedCategories) ? allowedCategories : null;
  const usePortalLabels = Boolean(allowed?.includes('self') && !allowed?.includes('faculty_staff'));
  const catalog = usePortalLabels ? PORTAL_FACULTY_OPTIONS : PUBLIC_OPTIONS;
  const options = allowed?.length ? catalog.filter((o) => allowed.includes(o.id)) : catalog;

  return (
    <div className="border-t border-white/10 pt-4 mt-4" data-testid="booking-category-step">
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="text-[11px] uppercase tracking-wider text-zinc-400">Who is the patient?</p>
          <p className="text-[11px] text-zinc-500 mt-0.5">
            {usePortalLabels
              ? 'Self, dependent family, or a non-dependent guest'
              : 'OPD consulting only — pick the matching campus category'}
          </p>
        </div>
        <button type="button" onClick={onBack} className="text-[11px] text-zinc-500 hover:text-zinc-300">Back</button>
      </div>
      <div className="space-y-2">
        {options.map((o) => {
          const active = value === o.id;
          return (
            <button
              key={o.id}
              type="button"
              onClick={() => onPick(o.id)}
              className={`w-full text-left rounded-xl border px-4 py-3 transition ${
                active ? 'border-white/40' : 'border-white/12 hover:bg-white/[0.06]'
              }`}
              style={active ? { borderColor: primary, background: `${primary}18` } : {}}
              data-testid={`booking-category-${o.id}`}
            >
              <p className="font-semibold text-zinc-100 text-sm">{o.title}</p>
              <p className="text-[11px] text-zinc-500 mt-0.5">{o.hint}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
